export default "__VITE_ASSET__CGENGeHc__"